<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface-title2"><a id="page-xi"></a><span href="#/toc#toc-preface003" title="Link target outside of Sample"><em>Author’s Note</em></span></h1>
<p class="noindent">Because “ch” is generally pronounced as an “h” in Gaelic, the Highland name Sorcha sounds like Sarah, rather than being phonetically pronounced. Sidony is Sidney. Kilchurn Castle is Kill-HERN. Dail Righ is Dal-REE.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface003.vue?571dced0